import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 7px 5px 7px 32px;
  background-color: oklch(1 0 none);
  border-bottom: 1px solid oklch(0.838 0.014 312);
`;

export const InfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px 16px 6px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background-color: #ffffff;
`;

export const Label = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #666;
  white-space: nowrap;
`;

export const Value = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
`;

